/** Zod validation schemas for Member Management endpoints */

import { z } from 'zod'
import { ROLES } from '../constants'

export const inviteMemberSchema = z.object({
  email: z.string().email(),
  role: z.enum(ROLES),
})

export const updateRoleSchema = z.object({
  role: z.enum(ROLES),
})
